import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import QuantumRadar from './pages/QuantumRadar';
import QuantumComputer from './pages/QuantumComputer';
import TrafficControl from './pages/TrafficControl';
import './App.css';

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/project/quantum-radar" element={<QuantumRadar />} />
        <Route path="/project/quantum-computer" element={<QuantumComputer />} />
        <Route path="/project/traffic-control" element={<TrafficControl />} />
      </Route>
    </Routes>
  );
}

export default App;
